
  import { Vue, Component } from 'vue-property-decorator';
  import { data } from './mc-receive.data';
  import { clone } from '@/utils';
  import { MealCountDto } from '@/models';
  
  @Component
  export default class McReceiveTests extends Vue {
    mealCount = data.mealCount;

    created() {
    }

    mounted() {
    }

    inputChanged() {

    }
  }
